import defaultAttributes from '../defaultAttributes';

const ArrowDownRight = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '7', y1: '7', x2: '17', y2: '17' }],
    ['polyline', { points: '17 7 17 17 7 17' }],
  ],
];

export default ArrowDownRight;
